import React from "react";
import { TwConfirmDialog } from "./tailwind";
import { useTranslation } from "react-i18next";


export default function MarkAsPaidDialog({ open, handleClose, onSubmit }) {
  const { t, i18n } = useTranslation();
  return (
    <TwConfirmDialog
      dialogOpen={open}
      dialogType="warning"
      dialogTitle={t("bookings.warning")}
      dialogMessage={t("bookings.changePaidStatusMsg")}
      onClose={handleClose}
      onConfirm={onSubmit}
    />
  )
}
